import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminBriefs from "./pages/AdminBriefs";
import AdminAnalytics from "./pages/AdminAnalytics";
import AdminShowreel from "./pages/AdminShowreel";
import AdminBlog from "./pages/AdminBlog";
import BriefConfirmation from "./pages/BriefConfirmation";
import BlogIndex from "./pages/BlogIndex";
import BlogArticle from "./pages/BlogArticle";
import { AuthProvider } from "./lib/AuthContext";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/admin" element={<AdminLogin />} />
                            <Route path="/admin/briefs" element={<AdminBriefs />} />
                            <Route path="/admin/analytics" element={<AdminAnalytics />} />
                            <Route path="/admin/showreel" element={<AdminShowreel />} />
                            <Route path="/admin/blog" element={<AdminBlog />} />
                            <Route path="/brief/:reference" element={<BriefConfirmation />} />
                            <Route path="/blog" element={<BlogIndex />} />
                            <Route path="/blog/:slug" element={<BlogArticle />} />
                        </Routes>
                    </BrowserRouter>
                </AuthProvider>
            </HelmetProvider>
            <Toaster
                position="bottom-right"
                theme="light"
                toastOptions={{
                    style: {
                        background: "#f1ece0",
                        color: "#272727",
                        border: "1px solid rgba(39,39,39,0.14)",
                    },
                }}
            />
        </div>
    );
}

export default App;
